import { render, staticRenderFns } from "./ViewDetailModal.vue?vue&type=template&id=de41f2a2&scoped=true&"
import script from "./ViewDetailModal.vue?vue&type=script&lang=js&"
export * from "./ViewDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailModal.vue?vue&type=style&index=0&id=de41f2a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de41f2a2",
  null
  
)

export default component.exports